import { IPageProps } from './Page.types';
import { usePageStyles } from './Page.styles';
import { useEffect } from 'react';
import ReactPixel from 'react-facebook-pixel';
import { Config } from 'config';
import { getComplianzConsent } from 'utils/tracking';

const Page = (props: IPageProps) => {
    const { children } = props;

    const styles = usePageStyles();

    useEffect(() => {
        const options = {
            autoConfig: true,
            debug: Config.reactPixelDebug
        };

        const consent = getComplianzConsent();
        if (consent.marketing === 'allow' && typeof ReactPixel.init === 'function') {
            ReactPixel.init(Config.reactPixelId, undefined, options);
        }

        if (props.title) {
            document.title = props.title;
        }

        if (props.description) {
            document
                .getElementsByTagName('meta')
                .namedItem('description')
                ?.setAttribute('content', props.description);
        }

        if (props.keywords) {
            document
                .getElementsByTagName('meta')
                .namedItem('keywords')
                ?.setAttribute('content', props.keywords);
        }
    }, [props.title, props.description, props.keywords]);

    return <div className={styles.root}>{children}</div>;
};

export default Page;
